/** Recommended reviewed examples per label in Improvement Mode / Improve wizard. */

export const MIN_VALIDATIONS_PER_LABEL = 15;

export function reviewGoalForCounts(counts) {
    return MIN_VALIDATIONS_PER_LABEL + (counts?.latest_validated || 0);
}

export function isReviewGoalMet(counts) {
    return (counts?.validated || 0) >= reviewGoalForCounts(counts);
}

export function classificationLabelsWithCounts(validationProgress, allLabelOptions) {
    const fromProgress = Object.keys(validationProgress || {});
    const fromOptions = allLabelOptions?.label_names || [];
    return Array.from(new Set([...fromProgress, ...fromOptions])).filter(
        (label) => (validationProgress?.[label]?.total || 0) > 0,
    );
}

export function firstIncompleteReviewLabel(validationProgress, allLabelOptions) {
    return classificationLabelsWithCounts(validationProgress, allLabelOptions).find(
        (label) => !isReviewGoalMet(validationProgress[label]),
    ) || null;
}

export function areAllClassificationReviewGoalsMet(validationProgress, allLabelOptions) {
    const labels = classificationLabelsWithCounts(validationProgress, allLabelOptions);
    if (labels.length === 0) return true;
    return labels.every((label) => isReviewGoalMet(validationProgress[label]));
}
